<template>
  <div :class="isSidebarOpen ? 'open' : 'closed'" class="side-bar-comp-search"
    data-test-id="sidebar-comp-search">
    <ExpandCollapse name="sidebar" :is-open-initially="true" :is-vertical-center="false" open-state="left"
      closed-state="right-zero" :show-double-chevron="true"
      @toggle-expand-collapse="toggleSidebar(); $emit('resize-sidebar-comp-search')" :show-circle="true" />
    <div class="comp-search" :class="!isSidebarOpen ? 'hidden' : ''">
      <form @submit.prevent="submitForm(); $emit('comp-search-submit')">
        <!-- Header-->
        <div class="header-search">
          <div>
            <div class="comp-search-title left-div">Search DDA Projects</div>
          </div>
          <div>
            <button class="right-div secondary-action-button my-searches">My Searches</button>
          </div>
        </div>
        
        <!-- Location Search Heading -->
        <div class="location-search-heading">Where are you looking to build?</div>
        
        <div class="location-container">
          <div v-if="$route.name === 'Home' ? true : false">
            <input id="location" data-test-id="location" class="location-search-box" 
              ref="locationInput"
              v-model="selectedPlaceName"
              placeholder="Enter address, neighborhood, or city" 
              style="font-size: medium" 
              autocomplete="off" />
              </div>
              </div>
        
        <!-- Radius Search Section -->
        <div class="radius-search-container">
          <div class="radius-checkbox-container" @click="useRadiusSearch = !useRadiusSearch; onRadiusToggle()">
            <input type="checkbox" v-model="useRadiusSearch" @change="onRadiusToggle">
            <label>Search within radius</label>
              </div>
          <div v-if="useRadiusSearch" class="radius-input-container">
            <input type="number" v-model="radiusMiles" @input="onRadiusChange" min="1" max="100" class="radius-input">
            <span class="radius-label">miles</span>
            </div>
          </div>
        
        <!-- Scope Search Section -->
        <div class="scope-search-container">
          <div class="radius-checkbox-container" @click="useScopeSearch = !useScopeSearch">
            <input type="checkbox" v-model="useScopeSearch">
            <label>Search by Budget Scope</label>
          </div>
          <div v-if="useScopeSearch" class="scope-input-container">
            <div class="autocomplete-wrapper">
              <input 
                type="text" 
                v-model="scopeSearchTerm" 
                @input="onScopeSearchInput"
                @focus="showScopeDropdown = true"
                placeholder="Search DDA terms (e.g., Concrete, HVAC, Electrical)"
                class="scope-search-input"
              />
              <div v-if="showScopeDropdown && scopeSuggestions.length > 0" class="scope-dropdown">
                <div 
                  v-for="term in scopeSuggestions" 
                  :key="term.id"
                  @click="selectScopeTerm(term)"
                  class="scope-dropdown-item"
                >
                  <span class="term-name">{{ term.name }}</span>
                  <span v-if="term.category" class="term-category">{{ term.category }}</span>
                </div>
              </div>
            </div>
            <div v-if="selectedScopeTerms.length > 0" class="selected-scopes">
              <div v-for="term in selectedScopeTerms" :key="term.id" class="scope-tag">
                {{ term.name }}
                <button @click="removeScopeTerm(term.id)" class="remove-scope">×</button>
              </div>
            </div>
          </div>
        </div>
        
        <div class="divider"></div>

        <!-- Building Details-->
        <div class="building-details-container">
          <div class="accordion-panel-header">
            <label for="buildingDetails"><strong>Building Details</strong></label>
            <ExpandCollapse name="buildingDetails" :is-open-initially="true" :is-vertical-center="false"
              open-state="down" closed-state="up" :show-double-chevron="false" :show-circle="false"
              :chevron-fill="'#4A5FD5'"
              @toggle-expand-collapse="expandCollapseController('buildingDetails');" />
          </div>
          <div v-if="isBuildingDetailsOpen">
            <!-- Asset Type -->
            <div class="asset-type-container">
              <div class="header-details-with-desc">
                <div>Asset Type</div>
                <p>(Select All That Apply)</p>
              </div>
              <ul >
                <li data-test-id="asset-type-checkbox-list" class="asset-type-input-container" v-for="(assetType, index) in assetCategoryFilteredTypes" :key="index">
                  <label class="custom-checkbox">
                    <span :for="assetType" class="custom-checkbox-label">{{ assetType.code }}</span>
                    <input type="checkbox" style="display: none;" :id="`asset-type-${assetType.id}`"
                      v-model="assetTypes" :value="assetType.id">
                    <span class="checkmark"></span>
                  </label>
                </li>
                <li  data-test-id="building-use-type-checkbox-list" class="asset-type-input-container" v-for="(buildingUseType, index) in buildingUseFilteredTypes" :key="index">
                  <label class="custom-checkbox">
                    <span :for="buildingUseType" class="custom-checkbox-label">{{ buildingUseType.code }}</span>
                    <input type="checkbox" style="display: none;" :id="buildingUseType.id"
                      v-model="buildingUseTypes" :value="buildingUseType.id">
                    <span class="checkmark"></span>
                  </label>
                </li>
              </ul>
            </div>
            <!-- Parking Type -->
            <div class="parking-type-container">
              <div class="header-details-with-desc">
                <div>Parking Type</div>
                <p>(Select All That Apply)</p>
              </div>
              <ul>
                <li data-test-id="parking-type-checkbox-list" class="parking-type-input-container" v-for="(parkingType, index) in parkingTypesDropdown"
                  :key="index">
                  <div class="width-100">
                    <label class="custom-checkbox">
                      <span :for="parkingTypes" class="custom-checkbox-label"> {{
    parkingType.code }}</span>
                      <input type="checkbox" style="display: none"
                        :id="'parkingType_' + parkingType.id" v-model="parkingTypes"
                        :value="parkingType.id"
                        @click="parkingType.isChecked = !parkingType.isChecked">
                      <span class="checkmark"></span>
                    </label>

                  </div>
                  <!-- todo: hide as of the moment since it's not functional-->
                  <!-- <div class="checkbox-text-input">
                    <input type="number" min="0"
                      @input="parkingTypes[index].valid || (value = '');"
                      :id="parkingType.name" v-model="parkingTypes[index]"
                      :disabled="!parkingType.isChecked" placeholder="--" />
                  </div> -->

                </li>
              </ul>
            </div>
            <!-- Construction Completion Date -->
            <div class="construction-completion-date-container">
              <div class="header-details">
                Construction Completion Date
              </div>
              <div data-test-id="year-completed" class="construction-completion-date-input-container label-text-spacing">
                <label class="left-div width-100">Year Completed</label>
                <div class="right-div">
                  <input type="number" min="0" id="yearBuildFrom" v-model="yearBuild[0]" />
                  <p>to</p>
                  <input type="number" min="0" id="yearBuildTo" v-model="yearBuild[1]" />
                </div>
              </div>
            </div>
            <!-- Sizing -->
            <div class="sizing-container">
              <div class="header-details">
                Sizing
              </div>
              <div data-test-id="square-feet" class="sizing-input-container label-text-spacing">
                <label class="left-div width-100">Square Feet</label>
                <div class="right-div">
                  <input type="number" min="0" id="squareFeetFrom" v-model="squareFeet[0]" />
                  <p>to</p>
                  <input type="number" min="0" id="squareFeetTo" v-model="squareFeet[1]" />
                </div>
              </div>
              <div data-test-id="number-of-units" class="units-input-container label-text-spacing">
                <label class="left-div width-100">Number of Units</label>
                <div class="right-div">
                  <input type="number" min="0" id="numberOfUnitsFrom"
                    v-model="numberOfUnits[0]" />
                  <p>to</p>
                  <input type="number" min="0" id="numberOfUnitsTo" v-model="numberOfUnits[1]" />
                </div>
              </div>
              <div data-test-id="number-of-floors" class="floors-input-container label-text-spacing">
                <label class="left-div width-100">Number of Floors</label>
                <div class="right-div">
                  <input type="number" min="0" id="numberOfFloorsFrom"
                    v-model="numberOfFloors[0]" />
                  <p>to</p>
                  <input type="number" min="0" id="numberOfFloorsTo"
                    v-model="numberOfFloors[1]" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>

        <!-- Construction Details -->
        <div class="construction-details-container">
          <div class="accordion-panel-header">
            <label for="constructionDetails"><strong>Construction Details</strong></label>
            <ExpandCollapse name="constructionDetails" :is-open-initially="true" :is-vertical-center="false"
              open-state="down" closed-state="up" :show-double-chevron="false" :show-circle="false"
              :chevron-fill="'#4A5FD5'"
              @toggle-expand-collapse="expandCollapseController('constructionDetails');" />
          </div>
          <div v-if="isConstructionDetailsOpen">
            <!-- Construction Type -->
            <div class="construction-type-container">
              <div class="header-details-with-desc">
                <div>Construction Type</div>
                <p>(Select All That Apply)</p>
              </div>
              <ul>
                <li data-test-id="construction-types-checkbox-list" class="construction-type-input-container" v-for="(constructionType, index) in constructionTypesDropdown" :key="index">
                  <label class="custom-checkbox">
                    <span :for="constructionType" class="custom-checkbox-label"> {{
    constructionType.code
  }}</span>
                    <input type="checkbox" style="display: none;" :id="constructionType.id"
                      v-model="constructionTypes" :value="constructionType.id">
                    <span class="checkmark"></span>
                  </label>
                </li>
              </ul>
            </div>
            <!-- Project Buyout Date -->
            <!-- <div class="project-buyout-date-container">
              <div class="header-details">Project Buyout Date</div>
              <div class="project-buyout-date-input-container label-text-spacing">
                <label class="left-div width-100">Year Pricing Locked In</label>
                <div class="right-div">
                  <input type="number" min="0"
                    id="yearPricingLockedInFrom" v-model="yearPricingLockedIn[0]" />
                  <p>to</p>
                  <input type="number" min="0"
                    id="yearPricingLockedInTo" v-model="yearPricingLockedIn[1]" />
                </div>
              </div>
            </div> -->
            <!-- Scopes of Work -->
            <div class="scope-of-work-container">
              <div class="header-details">
                Scopes of Work
              </div>
              <div class="custom-select label-text-spacing">
                <label class="left-div width-100" for="demolition">Demolition</label>
                <select class="right-div" id="demolition" v-model="demolition">
                  <option value="">Select Option</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div class="custom-select label-text-spacing">
                <label class="left-div width-100" for="abatement">Abatement</label>
                <select class="right-div" id="abatement" v-model="abatement">
                  <option value="">Select Option</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div class="custom-select label-text-spacing">
                <label class="left-div width-100" for="foundationType">Foundation Type</label>
                <select class="right-div" id="foundationType" v-model="foundationType">
                  <option value="">Select Option</option>
                  <option value="1">Slab on Grade</option>
                  <option value="2">Cellar</option>
                  <option value="3">Deep</option>
                </select>
              </div>
              <!-- Just put multiple="true" to bring back multiple select in dropdown-->
              <div class="custom-select label-text-spacing"
                tooltip="Use ctrl or cmd to do multiple selection">
                <label class="left-div width-100" for="structuralType">Structural Type</label>
                <select class="right-div" id="structuralType" v-model="structuralType">
                  <option value="">Select Option</option>
                  <option v-for="(structuralType, index) in structuralTypes" :key="index" :value="structuralType.name">{{
    structuralType.name }}</option>
                </select>
              </div>
              <div class="custom-select label-text-spacing">
                <label class="left-div width-100" for="windowType">Window Type</label>
                <select class="right-div" id="windowType" v-model="windowType">
                  <option value="">Select Option</option>
                  <option v-for="(windowType, index) in windowTypes" :key="index" :value="windowType.name">{{ windowType.name
                    }}
                  </option>
                </select>
              </div>

              <div class="custom-select label-text-spacing">
                <label class="left-div width-100" for="facadeType">Facade Type</label>
                <select class="right-div" id="facadeType" v-model="facadeType">
                  <option value="">Select Option</option>
                  <option v-for="(facadeType, index) in facadeTypes" :key="index" :value="facadeType.name">{{ facadeType.name
                    }}
                  </option>
                </select>
              </div>
              <div class="custom-select label-text-spacing">
                <label class="left-div width-100" for="interiorFinishLevel">Interior Finish
                  Level</label>
                <select class="right-div" id="interiorFinishLevel" v-model="interiorFinishLevel">
                  <option value="">Select Option</option>
                  <option v-for="(finishLevelType, index) in finishLevelTypes"
                    :value="finishLevelType.id" :key="index">{{ finishLevelType.code
                    }}</option>
                </select>
              </div>
            </div>

            <div class="divider"></div>

            <!-- Escalation Panel -->
            <div class="escalation">
              <div class="header-details">Apply Escalation</div>
              <div class="escalation-options">
                <div class="escalation-option cpi">
                  <span class="escalation-label font-pale-blue-1">CPI (YoY)</span>
                  <span class="escalation-checkbox">
                    <label class="custom-checkbox">
                      <input type="checkbox" style="display: none;" id="cpi" v-model="useCPI" @change="applyCPIEscalation">
                      <span class="checkmark"></span>
                    </label>
                  </span>
                </div>
                <div class="escalation-option or">
                  <span class="escalation-label">or</span>
                </div>
                <div class="escalation-option custom">
                  <span class="escalation-label">Custom (YoY)</span>
                  <span class="escalation-input">
                    <input type="number" step="0.01" min="0.01" max="100.0" id="escalation"
                           v-model="escalation"
                           @change="updateEscalation" />%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>

        <!-- Action Buttons -->
        <div data-test-id="comp-search-button" class="action-btn-container">
          <div class="left-div">
            <button class="secondary-action-button clear-filters" @click="clearFilters();">Clear Filters</button>
            <button class="secondary-action-button save-filters">Save Filters</button>
          </div>
          <div class="right-div">
            <button class="primary-action-button comp-search-button" type="submit">Search Comp Set</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { facadeTypesData, structuralTypesData, windowTypesData } from "@/data/data";
import { onMounted, onUnmounted, computed, reactive, ref, watch, defineEmits } from 'vue';
import ExpandCollapse from "../helpers/ExpandCollapse.vue";
import { useCompSetStore } from "@/stores/comp_set_store";
import { useDropdownStore } from "@/stores/dropdown_store";
import { useErrorStore } from "@/stores/error_store";
import { useAuthStore } from "@/stores/auth_store";
import { axiosQuery } from "@/assets/js/utils";
import { ASSET_CATEGORY_TYPES, BUILDING_USE_TYPES_RESIDENTIAL } from "@/types/Constants";
import qs from 'qs'; // qs is a querystring parsing library
import { fetchImage } from "@/assets/js/image_utils";
import { useFormStore } from '@/stores/form_store';
import { storeToRefs } from 'pinia';
import { useMathSummaryStore } from "@/stores/math_summary_store";
import { VIEW_MODES_TGU } from "@/types/Constants";
import { loadGoogleMapsAPI } from "../../main.js";
import DDADataService from "@/services/ddaDataService";
import axios from 'axios';

// Define emits
const emit = defineEmits(['resize-sidebar-comp-search', 'comp-search-submit', 'map-reset', 'filters-cleared']);

const dropdownStore = useDropdownStore();
const compSetStore = useCompSetStore()
const mathSummaryStore = useMathSummaryStore()
const errorStore = useErrorStore();

const formStore = useFormStore();
const {
  assetTypes,
  buildingUseTypes,
  parkingTypes,
  yearBuild,
  squareFeet,
  numberOfUnits,
  numberOfFloors,
  constructionTypes,
  demolition,
  abatement,
  foundationType,
  structuralType,
  windowType,
  facadeType,
  interiorFinishLevel,
  escalation } = storeToRefs(formStore); 

function clearFilters() {
  console.log('Clearing all filters');
  
  // Reset the form state
  formStore.resetForm();
  
  // Clear the selected place
  selectedPlace.value = null;
  selectedPlaceName.value = '';
  
  // Clear radius search state
  useRadiusSearch.value = false;
  radiusMiles.value = 5;
  
  // Clear the autocomplete input field
  const autocompleteInput = document.getElementById('autocomplete');
  if (autocompleteInput) {
    autocompleteInput.value = '';
  }
  
  // Clear the location input field specifically
  const locationInput = document.getElementById('location');
  if (locationInput) {
    locationInput.value = '';
  }
  
  // Clear all filter dropdowns
  assetTypes.value = [];
  buildingUseTypes.value = [];
  numberOfFloors.value = [];
  numberOfUnits.value = [];
  yearBuild.value = [];
  squareFeet.value = [];
  parkingTypes.value = [];
  constructionTypes.value = [];
  
  // Clear scopes of work filters
  demolition.value = '';
  abatement.value = '';
  foundationType.value = '';
  structuralType.value = '';
  windowType.value = '';
  facadeType.value = '';
  interiorFinishLevel.value = '';
  escalation.value = '';
  
  // Clear all comp set data in the store
  compSetStore.clearCompSetData();
  
  // Clear any search center
  searchCenter.value = null;
  
  // Force close any visible modals or panels
  const compSummaryModal = document.getElementById('comp-summary-modal');
  if (compSummaryModal) {
    compSummaryModal.classList.remove('open');
    compSummaryModal.style.display = 'none';
    compSummaryModal.style.width = '0';
    compSummaryModal.style.visibility = 'hidden';
    compSummaryModal.style.opacity = '0';
  }
  
  // Remove any loading indicators or remnants
  const loadingIndicators = document.querySelectorAll('.loading-indicator');
  loadingIndicators.forEach(indicator => {
    if (document.body.contains(indicator)) {
      document.body.removeChild(indicator);
    }
  });
  
  // Clear any white overlays or remnants from the DOM
  const overlayElements = document.querySelectorAll('.overlay-spinner, .spinner-overlay, .modal-overlay');
  overlayElements.forEach(overlay => {
    overlay.remove();
  });
  
  // First emit the map-reset event to reset the map completely
  emit('map-reset', null);
  
  // Then emit the filters-cleared event to trigger showAllPins in HomeView.vue
  setTimeout(() => {
    emit('filters-cleared');
  }, 300); // Increased timeout to ensure map reset completes
}

const structuralTypes = ref(structuralTypesData);
const windowTypes = ref(windowTypesData);
const facadeTypes = ref(facadeTypesData);

// Toggle Values
let isBuildingDetailsOpen = ref(true);
let isConstructionDetailsOpen = ref(true);

const expandCollapseController = (element) => {
  switch (element) {
    case 'buildingDetails':
      isBuildingDetailsOpen.value = !isBuildingDetailsOpen.value
      break;
    case 'constructionDetails':
      isConstructionDetailsOpen.value = !isConstructionDetailsOpen.value
      break;
    default:
      break;
  }
}

let isSidebarOpen = ref(true)
const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value
}

const apiBase = process.env.VUE_APP_ENV_API_BASE || "http://167.172.25.255:3000/api/v1/"
let authToken = reactive({});

// CPI checkbox state
const useCPI = ref(false);

// Apply CPI escalation when checkbox is clicked
function applyCPIEscalation() {
  if (useCPI.value) {
    // From memory ID 12099746: CPI is temporarily hardcoded to 21.2% while BLS API is being fixed
    escalation.value = 21.2;
    compSetStore.setEscalation(21.2);
    console.log('✅ CPI escalation applied: 21.2%');
  } else {
    escalation.value = '';
    compSetStore.setEscalation('');
    console.log('❌ CPI escalation removed');
  }
}

// FIXED: Allow escalation to be applied for ANY value, not just <2%
function updateEscalation() {
  if (escalation.value != null && escalation.value !== '') {
    compSetStore.setEscalation(escalation.value);
    console.log('✅ Custom escalation applied:', escalation.value + '%');
  }
}

const submitForm = async () => {
  try {
    console.log('🔍 PRECISE COMP SEARCH: Starting coordinate-based filtering');
    
    // Set the escalation value in the store
    compSetStore.setEscalation(escalation);
    
    // Set scope search data in the store
    console.log('🔍 SCOPE SEARCH: useScopeSearch =', useScopeSearch.value);
    console.log('🔍 SCOPE SEARCH: selectedScopeTerms.length =', selectedScopeTerms.value.length);
    console.log('🔍 SCOPE SEARCH: selectedScopeTerms =', JSON.stringify(selectedScopeTerms.value));
    compSetStore.setUseScopeSearch(useScopeSearch.value);
    compSetStore.setScopeSearchTerms(selectedScopeTerms.value);
    console.log('✅ SCOPE SEARCH: Saved to store - useScopeSearch:', compSetStore.getUseScopeSearch);
    console.log('✅ SCOPE SEARCH: Saved to store - terms.length:', compSetStore.getScopeSearchTerms.length);
    console.log('✅ SCOPE SEARCH: Saved to store - terms:', JSON.stringify(compSetStore.getScopeSearchTerms));
    
    // Set the view mode
    mathSummaryStore.setViewModeBy(VIEW_MODES_TGU.VIEW_BY_TOTAL);
    
    // Check if there's a drawn circle on the map (PRIORITY #1)
    const hasDrawnCircle = window.drawnCircle && window.mapCenter && window.mapCenter.length >= 3;
    
    if (hasDrawnCircle) {
      console.log('🎯 PRECISE CIRCLE: Using UI drawn circle with all filters');
      
      // Use the precise circle coordinates with all filters
      await executeCircleSearchWithFilters();
      return;
    }
    
    // Check for AI location input (PRIORITY #2)
    if (selectedPlaceName.value) {
      console.log('🧠 AI LOCATION: Converting location name to precise coordinates');
      
      // Use AI + Vector DB to convert location to precise coordinates
      await executeAILocationSearchWithFilters();
      return;
    }
    
    // No location specified - just apply filters
    console.log('📊 FILTERS ONLY: No location specified, applying just filters');
    await executeFiltersOnlySearch();
    
  } catch (error) {
    console.error('🚨 PRECISE COMP SEARCH Error:', error);
    showNotification('Error searching projects. Please try again.', 'error');
    
    // Remove loading indicator on error
    const loadingIndicator = document.querySelector('.loading-indicator');
    if (loadingIndicator && loadingIndicator.parentNode) {
      loadingIndicator.parentNode.removeChild(loadingIndicator);
    }
  }
}

// 🎯 PRECISE CIRCLE SEARCH: Use UI drawn circle + all filters
const executeCircleSearchWithFilters = async () => {
  try {
    console.log('🎯 Starting precise circle search with all filters');
    
    // Get precise circle coordinates from the UI
    const circleCenter = {
      lat: window.mapCenter[0],
      lng: window.mapCenter[1],
      radius_miles: window.mapCenter[2] / 1609.34 // Convert meters to miles
    };
    
    console.log('🎯 Circle coordinates:', circleCenter);
    
    // Build complete filter set
    const filters = buildAllFilters();
    
    // Add precise location parameter for backend
    filters.location = `${circleCenter.lat},${circleCenter.lng},${circleCenter.radius_miles * 1609.34}`; // Backend expects meters
    
    console.log('🎯 Complete filters with circle:', filters);
    
    // Send to backend API with precise coordinates + all filters
    const results = await executeBackendSearch(filters);
    
    // Process and display results
    await processSearchResults(results, 'circle');
    
  } catch (error) {
    console.error('🚨 Circle search error:', error);
    throw error;
  }
};

// 🧠 AI LOCATION SEARCH: Convert location name to coordinates + all filters  
const executeAILocationSearchWithFilters = async () => {
  try {
    console.log('🧠 Processing location search:', selectedPlaceName.value);
    
    // Build complete filter set
    const filters = buildAllFilters();
    
    // Add location parameter based on radius setting
    if (useRadiusSearch.value && radiusMiles.value) {
      // Radius search enabled - convert to coordinates
      console.log('🧠 Converting location name to coordinates for radius search:', selectedPlaceName.value);
      const locationCoords = await convertLocationToCoordinates(selectedPlaceName.value);
      
      if (!locationCoords) {
        throw new Error('Could not convert location to coordinates');
      }
      
      console.log('🧠 AI converted location to coordinates:', locationCoords);
      filters.location = `${locationCoords.lat},${locationCoords.lng},${radiusMiles.value * 1609.34}`;
      console.log('🧠 Using specified radius:', radiusMiles.value, 'miles');
    } else {
      // No radius search - send location NAME directly to backend for smart text-based filtering
      // Backend will use ZIP code-based borough detection (Manhattan, Brooklyn, etc.)
      // Extract just the place name (e.g., "Manhattan") not the full formatted address
      const locationName = selectedPlace.value?.name || selectedPlaceName.value.split(',')[0].trim();
      filters.location = locationName;
      console.log('🧠 Using smart text-based location filter (backend will match by borough/ZIP):', locationName);
    }
    
    console.log('🧠 Complete filters:', filters);
    
    // Send to backend API with location filter
    const results = await executeBackendSearch(filters);
    
    // Process and display results
    await processSearchResults(results, 'ai-location');
    
    // 🧠 VECTOR LEARNING: Record the AI location learning (only if we converted to coordinates)
    if (useRadiusSearch.value && radiusMiles.value) {
      // We have coordinates from the radius search path
      const locationCoords = await convertLocationToCoordinates(selectedPlaceName.value);
      if (locationCoords) {
        await recordAILocationLearning(selectedPlaceName.value, locationCoords, results.length);
      }
    } else {
      console.log('🧠 Skipping AI location learning for text-based search');
    }
    
  } catch (error) {
    console.error('🚨 AI location search error:', error);
    throw error;
  }
};

// 📊 FILTERS ONLY SEARCH: Apply all filters without location constraint
const executeFiltersOnlySearch = async () => {
  try {
    console.log('📊 Executing filters-only search');
    
    // Build complete filter set (no location)
    const filters = buildAllFilters();
    
    console.log('📊 Filters without location:', filters);
    
    // Send to backend API with just filters
    const results = await executeBackendSearch(filters);
    
    // Process and display results
    await processSearchResults(results, 'filters-only');
    
  } catch (error) {
    console.error('🚨 Filters-only search error:', error);
    throw error;
  }
};

// 🔧 BUILD ALL FILTERS: Construct complete filter object for backend
const buildAllFilters = () => {
  const filters = {};
  
  // Asset Types
  if (assetTypes.value && assetTypes.value.length > 0) {
    filters.primary_asset_category = assetTypes.value;
  }
  
  // Building Use Types
  if (buildingUseTypes.value && buildingUseTypes.value.length > 0) {
    filters.building_use_types_full = buildingUseTypes.value;
  }
  
  // Construction Types
  if (constructionTypes.value && constructionTypes.value.length > 0) {
    filters.project_construction_types_s = constructionTypes.value;
  }
  
  // Parking Types
  if (parkingTypes.value && parkingTypes.value.length > 0) {
    filters.parking_count = parkingTypes.value;
  }
  
  // Square Feet Range
  if (squareFeet.value && Array.isArray(squareFeet.value)) {
    const [minGsf, maxGsf] = squareFeet.value;
    if (minGsf !== undefined && minGsf !== null && minGsf !== '') {
      filters.total_gsf_min = minGsf;
    }
    if (maxGsf !== undefined && maxGsf !== null && maxGsf !== '') {
      filters.total_gsf_max = maxGsf;
    }
  }
  
  // Number of Units Range
  if (numberOfUnits.value && Array.isArray(numberOfUnits.value)) {
    const [minUnits, maxUnits] = numberOfUnits.value;
    if (minUnits !== undefined && minUnits !== null && minUnits !== '') {
      filters.total_num_units_min = minUnits;
    }
    if (maxUnits !== undefined && maxUnits !== null && maxUnits !== '') {
      filters.total_num_units_max = maxUnits;
    }
  }
  
  // Number of Floors Range
  if (numberOfFloors.value && Array.isArray(numberOfFloors.value)) {
    const [minFloors, maxFloors] = numberOfFloors.value;
    if (minFloors !== undefined && minFloors !== null && minFloors !== '') {
      filters.num_floors_min = minFloors;
    }
    if (maxFloors !== undefined && maxFloors !== null && maxFloors !== '') {
      filters.num_floors_max = maxFloors;
    }
  }
  
  // Year Built Range
  if (yearBuild.value && Array.isArray(yearBuild.value)) {
    const [minYear, maxYear] = yearBuild.value;
    if (minYear !== undefined && minYear !== null && minYear !== '') {
      filters.actual_end_date_min = minYear;
    }
    if (maxYear !== undefined && maxYear !== null && maxYear !== '') {
      filters.actual_end_date_max = maxYear;
    }
  }
  
  // Scopes of Work filters
  if (demolition.value && demolition.value.length > 0) {
    filters.demolition = demolition.value;
  }
  if (abatement.value && abatement.value.length > 0) {
    filters.abatement = abatement.value;
  }
  if (foundationType.value && foundationType.value.length > 0) {
    filters.foundation_type = foundationType.value;
  }
  if (structuralType.value && structuralType.value.length > 0) {
    filters.structural_type = structuralType.value;
  }
  if (windowType.value && windowType.value.length > 0) {
    filters.window_type = windowType.value;
  }
  if (facadeType.value && facadeType.value.length > 0) {
    filters.facade_type = facadeType.value;
  }
  if (interiorFinishLevel.value && interiorFinishLevel.value.length > 0) {
    filters.interior_finish_level = interiorFinishLevel.value;
  }
  
  // Remove empty values
  const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        acc[key] = value;
      }
    } else {
      if (value !== null && value !== undefined && value !== '') {
        acc[key] = value;
      }
    }
    return acc;
  }, {});
  
  return cleanFilters;
};

// 🚀 BACKEND API SEARCH: Send filters to backend with precise coordinates
const executeBackendSearch = async (filters) => {
  try {
    console.log('🚀 Sending filters to backend API:', filters);
    
    // Show loading indicator
    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'loading-indicator';
    loadingIndicator.textContent = 'Searching DDA projects with precise filtering...';
    document.body.appendChild(loadingIndicator);
    
    // Get API configuration
    const apiBase = process.env.VUE_APP_ENV_API_BASE || "http://167.172.25.255:3000/api/v1/";
    const authStore = useAuthStore();
    const authToken = authStore.getAuthTokenHeader;
    
    // Convert filters to query string
    const queryString = Object.entries(filters).map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map(v => `${key}[]=${encodeURIComponent(v)}`).join('&');
      } else {
        return `${key}=${encodeURIComponent(value)}`;
      }
    }).join('&');
    
    console.log('🚀 Backend query string:', queryString);
    console.log('🚀 Full URL:', `${apiBase}projects?${queryString}`);
    
    // Make API request to backend
    const response = await axios.get(`${apiBase}projects?${queryString}`, {
      headers: authToken
    });
    
    // Remove loading indicator
    if (loadingIndicator && loadingIndicator.parentNode) {
      loadingIndicator.parentNode.removeChild(loadingIndicator);
    }
    
    console.log('🎯 Backend response:', response.data);
    
    return response.data || [];
    
  } catch (error) {
    console.error('🚨 Backend API error:', error);
    
    // Remove loading indicator on error
    const loadingIndicator = document.querySelector('.loading-indicator');
    if (loadingIndicator && loadingIndicator.parentNode) {
      loadingIndicator.parentNode.removeChild(loadingIndicator);
    }
    
    throw error;
  }
};

// 📊 PROCESS SEARCH RESULTS: Update store and show results
const processSearchResults = async (projects, searchType) => {
  try {
    console.log(`📊 Processing ${projects.length} results from ${searchType} search`);
    
    // Update the store with precise search results
    compSetStore.setAllProjects(projects);
    compSetStore.setIncludedProjects(projects);
    
    // Set all projects as selected
    const selectedProjectsObj = {};
    projects.forEach(p => selectedProjectsObj[p.id] = true);
    compSetStore.setSelectedProjects(selectedProjectsObj);
    
    // Show results notification
    const resultMessage = projects.length > 0 
      ? `Found ${projects.length} DDA projects with precise ${searchType} filtering`
      : `No projects found matching your ${searchType} criteria`;
    
    const notificationType = projects.length > 0 ? 'success' : 'warning';
    showNotification(resultMessage, notificationType);
    
    console.log(`✅ Successfully processed ${searchType} search: ${projects.length} projects`);
    
  } catch (error) {
    console.error('🚨 Results processing error:', error);
    throw error;
  }
};

// 🧠 AI LOCATION CONVERSION: Use AI + Vector DB to convert location names to coordinates
const convertLocationToCoordinates = async (locationName) => {
  try {
    console.log('🧠 AI converting location to coordinates:', locationName);
    
    // First try Google Places API if available
    if (selectedPlace.value && selectedPlace.value.geometry) {
      console.log('🧠 Using existing Google Places data');
      return {
        lat: selectedPlace.value.geometry.location.lat(),
        lng: selectedPlace.value.geometry.location.lng(),
        source: 'google_places'
      };
    }
    
    // Use our AI + Vector DB system to learn and convert location names
    const aiResponse = await axios.post('/api/v1/dda_terms/classify', {
      descriptions: [locationName],
      context: 'location_conversion',
      user_id: 1 // TODO: Get from auth
    });
    
    if (aiResponse.data && aiResponse.data.alternatives && aiResponse.data.alternatives.length > 0) {
      const locationData = aiResponse.data.alternatives[0];
      
      // Check if AI learned coordinates for this location
      if (locationData.coordinates) {
        console.log('🧠 AI found learned coordinates:', locationData.coordinates);
        return {
          lat: locationData.coordinates.lat,
          lng: locationData.coordinates.lng,
          source: 'ai_learned'
        };
      }
    }
    
    // Fallback: Use Google Geocoding API for unknown locations
    console.log('🧠 Using Google Geocoding API as fallback');
    const geocodeResponse = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: {
        address: locationName,
        key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY
      }
    });
    
    if (geocodeResponse.data.results && geocodeResponse.data.results.length > 0) {
      const result = geocodeResponse.data.results[0];
      const coords = {
        lat: result.geometry.location.lat,
        lng: result.geometry.location.lng,
        source: 'google_geocoding'
      };
      
      // 🧠 LEARN: Store this location conversion for future AI use
      await recordLocationCoordinateLearning(locationName, coords);
      
      return coords;
    }
    
    throw new Error(`Could not convert location "${locationName}" to coordinates`);
    
  } catch (error) {
    console.error('🚨 AI location conversion error:', error);
    throw error;
  }
};

// 🧠 VECTOR LEARNING: Record AI location conversion for future learning
const recordAILocationLearning = async (locationName, coordinates, resultCount) => {
  try {
    await axios.post('/api/v1/learning/record_feedback', {
      interaction_type: 'location_conversion',
      context: {
        query: locationName,
        coordinates: coordinates,
        result_count: resultCount,
        user_id: 1, // TODO: Get from auth
        interaction_source: 'comp_search'
      }
    });
    console.log('🧠 Recorded AI location learning');
  } catch (error) {
    console.warn('🧠 Failed to record location learning:', error);
  }
};

// 🧠 VECTOR LEARNING: Record location coordinate mapping for AI
const recordLocationCoordinateLearning = async (locationName, coordinates) => {
  try {
    await axios.post('/api/v1/learning/record_feedback', {
      interaction_type: 'coordinate_mapping',
      context: {
        location_name: locationName,
        coordinates: coordinates,
        user_id: 1, // TODO: Get from auth
        interaction_source: 'comp_search_geocoding'
      }
    });
    console.log('🧠 Recorded coordinate mapping learning');
  } catch (error) {
    console.warn('🧠 Failed to record coordinate learning:', error);
  }
};

// 📢 SHOW NOTIFICATION: Display result messages to user
const showNotification = (message, type = 'info') => {
  try {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    
    // Style the notification
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 20px;
      border-radius: 8px;
      color: white;
      font-weight: 500;
      z-index: 10000;
      max-width: 400px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      transform: translateX(100%);
      transition: transform 0.3s ease;
    `;
    
    // Set color based on type
    switch(type) {
      case 'success':
        notification.style.backgroundColor = '#4ade80';
        break;
      case 'warning':
        notification.style.backgroundColor = '#f59e0b';
        break;
      case 'error':
        notification.style.backgroundColor = '#ef4444';
        break;
      default:
        notification.style.backgroundColor = '#3b82f6';
    }
    
    // Add to DOM
    document.body.appendChild(notification);
    
    // Animate in
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 10);
    
    // Remove after 4 seconds
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 4000);
    
  } catch (error) {
    console.warn('Failed to show notification:', error);
    // Fallback to console
    console.log(`${type.toUpperCase()}: ${message}`);
  }
};

const fetchActiveCompSet = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log('Fetching active comp set');
      
      // Define filter options for the project query (using correct database field names)
      let validFilterProjectOptions = {
        primary_asset_category: assetTypes.value,
        building_use_types_full: buildingUseTypes.value,
        num_floors: numberOfFloors.value,
        total_num_units: numberOfUnits.value,
        actual_end_date: yearBuild.value,
        total_gsf: squareFeet.value,
        parking_count: parkingTypes.value,
        project_construction_types_s: constructionTypes.value,
        // escalation: escalation.value,
      };
    
      // Remove null values from the options
      validFilterProjectOptions = Object.entries(validFilterProjectOptions).reduce((acc, [key, value]) => {
        if (value && Array.isArray(value) && value.some(v => v !== null && v !== undefined && v !== '')) {
          acc[key] = value;
        }
        return acc;
      }, {});
    
      // Convert the filter options to a query string
      const queryString = qs.stringify(validFilterProjectOptions, { arrayFormat: 'brackets' });
      compSetStore.setCompQuery(queryString);
      const compSetAndMapQuery = compSetStore.getQuery;
    
      // Fetch projects without images first to optimize performance
      const projects = await fetchProjects(compSetAndMapQuery);
      console.log(`Fetched ${projects.length} projects`);
      
      // Fetch images for projects
      // DISABLED: CompSummary now handles images via getPrimaryImageUrl() using documents array
      // const projectsWithImages = await fetchImagesForProjects(projects);
      const projectsWithImages = projects; // Don't fetch images here, let CompSummary handle it
      
      // Update the store with the fetched projects
      compSetStore.setAllProjects(projectsWithImages);
      compSetStore.setIncludedProjects(projectsWithImages);
    
      // Set all projects as selected
      const selectedProjects = Object.fromEntries(projects.map(project => [project.id, true]));
      compSetStore.setSelectedProjects(selectedProjects);
      
      resolve(projectsWithImages);
    } catch (error) {
      console.error('Error fetching active comp set:', error);
      errorStore.setError('Error', 'Failed to fetch projects', 'error');
      reject(error);
    }
  });
};

// Fetch projects from the API based on the query
const fetchProjects = async (query) => {
  return new Promise((resolve, reject) => {
    axiosQuery(
      `${apiBase}projects?${query}`,
      authToken,
      (data) => resolve(data),
      (error) => reject(error)
    );
  });
};

// Fetch images for each project and update the project data
const fetchImagesForProjects = async (projects) => {
  const projectsWithImagesPromises = projects.map((project) => {
    return fetchImage(project.id).then((renderedImage) => {
      project.image_url = renderedImage; // Update the image_url in the project data
      return project;
    });
  });

  return Promise.all(projectsWithImagesPromises);
};

const selectedPlace = ref(null);
const selectedPlaceName = ref('');

// Project autocomplete variables
const showProjectSuggestions = ref(false);
const projectSuggestions = ref([]);
const allProjectsForSearch = ref([]);

// Radius search variables
const useRadiusSearch = ref(false);
const radiusMiles = ref(5);
const searchCenter = ref(null);

// Scope search variables
const useScopeSearch = ref(false);
const scopeSearchTerm = ref('');
const showScopeDropdown = ref(false);
const scopeSuggestions = ref([]);
const selectedScopeTerms = ref([]);
const allDDATerms = ref([]);


// Google Places Autocomplete
const locationInput = ref(null);
let placesAutocomplete = null;

// Initialize Google Places Autocomplete
const initializePlacesAutocomplete = () => {
  if (!window.google || !window.google.maps || !window.google.maps.places) {
    console.error('Google Places API not loaded');
    return;
  }
  
  if (!locationInput.value) {
    console.error('Location input element not found');
    return;
  }
  
  // Configure autocomplete options
  const options = {
    types: ['geocode'], // Only return geocoding results (addresses, places)
    componentRestrictions: { country: 'us' }, // Restrict to US for now
    fields: ['place_id', 'geometry', 'name', 'formatted_address', 'types', 'address_components', 'address_component']
  };
  
  // Create the autocomplete instance
  placesAutocomplete = new window.google.maps.places.Autocomplete(locationInput.value, options);
  
  // Listen for place selection
  placesAutocomplete.addListener('place_changed', onPlaceSelected);
};

// Handle place selection from Google Places
const onPlaceSelected = () => {
  const place = placesAutocomplete.getPlace();
  
  if (!place.geometry || !place.geometry.location) {
    console.error('No geometry data for selected place');
    return;
  }
  
  // Update the selected place data
  selectedPlace.value = place;
  selectedPlaceName.value = place.formatted_address || place.name;
  
  // Store the search center for geographic filtering
  searchCenter.value = {
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng(),
    formatted_address: place.formatted_address || place.name
  };
  
  console.log('Place selected:', {
    name: place.name,
    formatted_address: place.formatted_address,
    location: searchCenter.value,
    types: place.types,
    place_id: place.place_id
  });
  
  // Just center on location - no boundaries or automatic querying
  if (place.place_id && (place.types?.includes('locality') || place.types?.includes('neighborhood') || place.types?.includes('sublocality') || place.types?.includes('administrative_area_level_3') || place.types?.includes('political'))) {
    console.log('Centering map on location:', place.name, 'types:', place.types);
    // Just center the map, don't draw boundaries or run queries until search is clicked
    centerMapOnLocation(searchCenter.value);
  } else if (useRadiusSearch.value) {
    // Use radius (circle) filtering
    applyRadiusFilter();
  } else if (place.geometry.viewport) {
    // Use basic bounds (rectangle) filtering as fallback
    const searchBounds = {
      northeast: {
        lat: place.geometry.viewport.getNorthEast().lat(),
        lng: place.geometry.viewport.getNorthEast().lng()
      },
      southwest: {
        lat: place.geometry.viewport.getSouthWest().lat(),
        lng: place.geometry.viewport.getSouthWest().lng()
      }
    };
    console.log('Using simple viewport bounds for basic filtering:', searchBounds);
    applyBoundsFilter(searchBounds);
  } else {
    // Fallback to just centering the map
    centerMapOnLocation(searchCenter.value);
  }
};

// Use Google's actual administrative boundaries with red dotted lines
// Removed useGoogleBuiltInBoundaries - just center map on location instead

// Get detailed place boundaries using Geocoding API for actual polygons
const getDetailedPlaceBoundaries = (placeId) => {
  if (!window.google || !window.google.maps) {
    console.error('Google Maps API not available');
    return;
  }
  
  // Use Geocoding API to get detailed geometry including polygons
  const geocoder = new window.google.maps.Geocoder();
  
  geocoder.geocode({
    placeId: placeId
  }, (results, status) => {
    if (status === 'OK' && results && results.length > 0) {
      const place = results[0];
      console.log('Geocoding result for detailed boundaries:', place);
      
      // Check if we have polygon geometry
      if (place.geometry && place.geometry.location) {
        // Try to get actual polygon coordinates if available
        if (place.geometry.bounds || place.geometry.viewport) {
          // For complex areas, try to get polygon data from administrative levels
          const adminComponents = place.address_components?.filter(component => 
            component.types.includes('sublocality') || 
            component.types.includes('neighborhood') || 
            component.types.includes('political')
          );
          
          if (adminComponents && adminComponents.length > 0) {
            console.log('Found administrative components:', adminComponents);
            // Try to get polygon outline using the area name
            getPolygonFromAreaName(adminComponents[0].long_name, place.geometry);
          } else {
            // Fallback to viewport bounds
            useViewportBounds(place.geometry);
          }
        }
      }
    } else {
      console.error('Geocoding failed:', status);
      centerMapOnLocation(searchCenter.value);
    }
  });
};

// Try to get polygon data for any area dynamically
const getPolygonFromAreaName = async (areaName, geometry) => {
  console.log(`Attempting to get dynamic polygon for: ${areaName}`);
  
  try {
    // Try to get actual polygon boundaries from external APIs
    const polygon = await getPolygonFromOverpassAPI(areaName, geometry.location);
    
    if (polygon && polygon.length > 3) {
      console.log(`Using dynamic polygon for ${areaName}:`, polygon.length, 'points');
      applyPolygonFilter(polygon, areaName);
    } else {
      console.log(`No complex polygon available for ${areaName}, using enhanced bounds`);
      // Fallback to enhanced bounds (better than simple rectangle)
      const enhancedPolygon = getEnhancedBoundsPolygon(geometry);
      if (enhancedPolygon) {
        applyPolygonFilter(enhancedPolygon, areaName);
      } else {
        useViewportBounds(geometry);
      }
    }
  } catch (error) {
    console.error(`Error getting polygon for ${areaName}:`, error);
    // Ultimate fallback to viewport bounds
    useViewportBounds(geometry);
  }
};

// Get polygon boundaries using Google Maps Data Layer or administrative boundaries
const getPolygonBoundariesFromGoogle = async (place, areaName) => {
  console.log(`Attempting to get dynamic polygon boundaries for: ${areaName}`);
  
  try {
    // Method 1: Try Google Places API with administrative_area_level requests
    if (place.address_components) {
      const adminLevels = place.address_components.filter(component => 
        component.types.some(type => 
          type.includes('administrative_area') || 
          type.includes('sublocality') ||
          type.includes('neighborhood') ||
          type.includes('political')
        )
      );
      
      if (adminLevels.length > 0) {
        console.log('Found administrative levels:', adminLevels);
        // Try to get boundary data from Overpass API or similar
        return await getPolygonFromOverpassAPI(adminLevels[0].long_name, place.geometry.location);
      }
    }
    
    // Method 2: Use the place bounds but with higher precision
    return getEnhancedBoundsPolygon(place.geometry);
    
  } catch (error) {
    console.error('Error getting polygon boundaries:', error);
    return null;
  }
};

// Get Google's detailed geometry using Geocoding API
const getGoogleDetailedGeometry = async (placeId) => {
  try {
    if (!window.google || !window.google.maps) {
      throw new Error('Google Maps API not available');
    }
    
    const geocoder = new window.google.maps.Geocoder();
    
    return new Promise((resolve, reject) => {
      geocoder.geocode({
        placeId: placeId,
        fields: ['geometry', 'formatted_address', 'name', 'types']
      }, (results, status) => {
        if (status === 'OK' && results && results.length > 0) {
          const result = results[0];
          console.log('Google Geocoding detailed result:', result);
          
          // Check if Google provided detailed geometry
          if (result.geometry && result.geometry.location) {
            // For some places, Google provides viewport bounds that are more accurate
            if (result.geometry.bounds || result.geometry.viewport) {
              const bounds = result.geometry.bounds || result.geometry.viewport;
              
              // Create a more detailed polygon from viewport (better than basic rectangle)
              const ne = bounds.getNorthEast();
              const sw = bounds.getSouthWest();
              
              // Create an enhanced polygon with more points around the boundary
              const polygon = createEnhancedBoundaryPolygon(ne, sw);
              resolve(polygon);
              return;
            }
          }
          
          resolve(null);
        } else {
          console.log('Google Geocoding failed:', status);
          resolve(null);
        }
      });
    });
    
  } catch (error) {
    console.error('Google Geocoding error:', error);
    return null;
  }
};

// Get Google Places detailed geometry
const getGooglePlacesGeometry = async (placeId) => {
  try {
    if (!window.google || !window.google.maps) {
      throw new Error('Google Maps API not available');
    }
    
    const service = new window.google.maps.places.PlacesService(document.createElement('div'));
    
    return new Promise((resolve, reject) => {
      service.getDetails({
        placeId: placeId,
        fields: ['geometry', 'name', 'formatted_address', 'types', 'address_components']
      }, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
          console.log('Google Places detailed result:', place);
          
          // Google Places sometimes has more detailed geometry
          if (place.geometry && place.geometry.location) {
            if (place.geometry.viewport) {
              const bounds = place.geometry.viewport;
              const ne = bounds.getNorthEast();
              const sw = bounds.getSouthWest();
              
              // Create enhanced boundary polygon
              const polygon = createEnhancedBoundaryPolygon(ne, sw);
              resolve(polygon);
              return;
            }
          }
          
          resolve(null);
        } else {
          console.log('Google Places failed:', status);
          resolve(null);
        }
      });
    });
    
  } catch (error) {
    console.error('Google Places error:', error);
    return null;
  }
};

// Create an enhanced boundary polygon from Google's viewport bounds
const createEnhancedBoundaryPolygon = (northeast, southwest) => {
  const neLat = northeast.lat();
  const neLng = northeast.lng();
  const swLat = southwest.lat();
  const swLng = southwest.lng();
  
  // Expand the bounds by 25% to be more inclusive for property filtering
  const latSpan = neLat - swLat;
  const lngSpan = neLng - swLng;
  const expansion = 0.25;
  
  const expandedNeLat = neLat + (latSpan * expansion);
  const expandedSwLat = swLat - (latSpan * expansion);
  const expandedNeLng = neLng + (lngSpan * expansion);
  const expandedSwLng = swLng - (lngSpan * expansion);
  
  console.log(`Creating expanded boundary: Original (${swLat}, ${swLng}) to (${neLat}, ${neLng})`);
  console.log(`Expanded to: (${expandedSwLat}, ${expandedSwLng}) to (${expandedNeLat}, ${expandedNeLng})`);
  
  // Create a more inclusive polygon
  const latMid = (expandedNeLat + expandedSwLat) / 2;
  const lngMid = (expandedNeLng + expandedSwLng) / 2;
  
  // Simple 8-point polygon that's more inclusive
  return [
    { lat: expandedNeLat, lng: expandedSwLng },    // NW corner
    { lat: expandedNeLat, lng: expandedNeLng },    // NE corner
    { lat: expandedSwLat, lng: expandedNeLng },    // SE corner
    { lat: expandedSwLat, lng: expandedSwLng },    // SW corner
    { lat: expandedNeLat, lng: expandedSwLng }     // Close polygon
  ];
};

// Get clean administrative boundary from Nominatim (more reliable for cities/neighborhoods)
const getNominatimBoundary = async (place) => {
  try {
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    
    // Use Nominatim reverse geocoding to get the OSM ID for this exact location
    const nominatimUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=10&polygon_geojson=1&extratags=1`;
    
    console.log(`Getting boundary from Nominatim for: ${place.name} at ${lat}, ${lng}`);
    
    const response = await fetch(nominatimUrl);
    if (!response.ok) {
      throw new Error(`Nominatim error: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Nominatim response:', data);
    
    // Check if we got a polygon in the geojson
    if (data.geojson && data.geojson.type === 'Polygon' && data.geojson.coordinates) {
      const coords = data.geojson.coordinates[0]; // Get outer ring
      const polygon = coords.map(coord => ({ lat: coord[1], lng: coord[0] }));
      
      if (polygon.length > 3) {
        console.log(`Got clean boundary from Nominatim: ${polygon.length} points`);
        return polygon;
      }
    }
    
    // If no polygon, try to get boundary by OSM relation ID
    if (data.osm_type === 'relation' && data.osm_id) {
      return await getOSMRelationBoundary(data.osm_id);
    }
    
    console.log('No polygon boundary found in Nominatim response');
    return null;
    
  } catch (error) {
    console.error('Nominatim API error:', error);
    return null;
  }
};

// Get boundary from OSM relation ID
const getOSMRelationBoundary = async (relationId) => {
  try {
    const overpassUrl = 'https://overpass-api.de/api/interpreter';
    const query = `
      [out:json][timeout:25];
      (
        relation(${relationId});
      );
      out geom;
    `;
    
    console.log(`Getting boundary for OSM relation: ${relationId}`);
    
    const response = await fetch(overpassUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `data=${encodeURIComponent(query)}`
    });
    
    if (!response.ok) {
      throw new Error(`Overpass API error: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.elements && data.elements.length > 0) {
      const element = data.elements[0];
      if (element.members) {
        // Get the outer boundary only (role="outer")
        const outerMembers = element.members.filter(m => m.role === 'outer' || !m.role);
        const coordinates = [];
        
        for (const member of outerMembers) {
          if (member.geometry && Array.isArray(member.geometry)) {
            member.geometry.forEach(point => {
              if (point.lat && point.lon) {
                coordinates.push({ lat: point.lat, lng: point.lon });
              }
            });
          }
        }
        
        if (coordinates.length > 3) {
          return coordinates;
        }
      }
    }
    
    return null;
  } catch (error) {
    console.error('OSM relation boundary error:', error);
    return null;
  }
};

// Enhanced viewport bounds (larger than basic viewport)
const getEnhancedViewportBounds = (geometry) => {
  const viewport = geometry.viewport;
  if (!viewport) return null;
  
  const ne = viewport.getNorthEast();
  const sw = viewport.getSouthWest();
  
  // Expand the viewport by 50% in each direction for much better coverage
  const latSpan = ne.lat() - sw.lat();
  const lngSpan = ne.lng() - sw.lng();
  const expansion = 0.5;
  
  return {
    northeast: {
      lat: ne.lat() + (latSpan * expansion),
      lng: ne.lng() + (lngSpan * expansion)
    },
    southwest: {
      lat: sw.lat() - (latSpan * expansion),
      lng: sw.lng() - (lngSpan * expansion)
    }
  };
};

// Get polygon from OpenStreetMap Overpass API (free alternative)
const getPolygonFromOverpassAPI = async (areaName, location) => {
  try {
    // Construct Overpass API query for administrative boundaries
    // Add a bounding box constraint to ensure we get the right geographic area
    const overpassUrl = 'https://overpass-api.de/api/interpreter';
    
    // Create a bounding box around the Google Places location (roughly 0.5 degrees in each direction)
    const lat = location.lat();
    const lng = location.lng();
    const bbox = `${lat - 0.5},${lng - 0.5},${lat + 0.5},${lng + 0.5}`;
    
    const query = `
      [out:json][timeout:25][bbox:${bbox}];
      (
        relation["name"="${areaName}"]["admin_level"]["boundary"="administrative"];
        relation["name"="${areaName}"]["place"];
        relation["name"~"${areaName}"]["admin_level"]["boundary"="administrative"];
        relation["name"~"${areaName}"]["place"];
      );
      out geom;
    `;
    
    console.log(`Querying Overpass API for: ${areaName} within bbox: ${bbox}`);
    
    const response = await fetch(overpassUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `data=${encodeURIComponent(query)}`
    });
    
    if (!response.ok) {
      throw new Error(`Overpass API error: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Overpass API response:', data);
    
    if (data.elements && data.elements.length > 0) {
      // Extract polygon coordinates from the response
      const element = data.elements[0];
      console.log(`Found ${data.elements.length} elements for ${areaName}:`, data.elements.map(e => e.tags?.name || 'unnamed'));
      
      if (element.members && element.members.length > 0) {
        const polygon = extractPolygonFromOverpassElement(element);
        if (polygon && polygon.length > 3) {
          console.log(`Successfully got ${polygon.length} polygon points from Overpass API for ${areaName}`);
          return polygon;
        }
      }
    }
    
    console.log(`No polygon data found in Overpass API response for ${areaName} within the specified geographic area`);
    return null;
    
  } catch (error) {
    console.error('Overpass API error:', error);
    return null;
  }
};

// Extract polygon coordinates from Overpass API element
const extractPolygonFromOverpassElement = (element) => {
  const coordinates = [];
  
  try {
    if (element.members) {
      for (const member of element.members) {
        if (member.geometry && Array.isArray(member.geometry)) {
          for (const point of member.geometry) {
            if (point.lat && point.lon) {
              coordinates.push({ lat: point.lat, lng: point.lon });
            }
          }
        }
      }
    }
    
    // Close the polygon if it's not already closed
    if (coordinates.length > 0) {
      const first = coordinates[0];
      const last = coordinates[coordinates.length - 1];
      if (first.lat !== last.lat || first.lng !== last.lng) {
        coordinates.push({ lat: first.lat, lng: first.lng });
      }
    }
    
    return coordinates;
  } catch (error) {
    console.error('Error extracting polygon coordinates:', error);
    return [];
  }
};

// Enhanced bounds polygon (better than simple rectangle)
const getEnhancedBoundsPolygon = (geometry) => {
  const bounds = geometry.viewport || geometry.bounds;
  if (!bounds) return null;
  
  const ne = bounds.getNorthEast();
  const sw = bounds.getSouthWest();
  
  // Create a more detailed rectangle with intermediate points
  return [
    { lat: ne.lat(), lng: sw.lng() },     // NW corner
    { lat: ne.lat(), lng: ne.lng() },     // NE corner
    { lat: sw.lat(), lng: ne.lng() },     // SE corner  
    { lat: sw.lat(), lng: sw.lng() },     // SW corner
    { lat: ne.lat(), lng: sw.lng() }      // Close polygon
  ];
};

// Apply polygon-based filtering
const applyPolygonFilter = (polygonCoords, areaName) => {
  console.log(`Applying polygon filter for ${areaName} with ${polygonCoords.length} points:`, polygonCoords);
  
  // Calculate bounds from polygon for zoom/center
  const lats = polygonCoords.map(p => p.lat);
  const lngs = polygonCoords.map(p => p.lng);
  
  const bounds = {
    northeast: {
      lat: Math.max(...lats),
      lng: Math.max(...lngs)
    },
    southwest: {
      lat: Math.min(...lats),
      lng: Math.min(...lngs)
    }
  };
  
  console.log(`Polygon bounds for ${areaName}:`, bounds);
  
  // Calculate center and zoom
  const centerLat = (bounds.northeast.lat + bounds.southwest.lat) / 2;
  const centerLng = (bounds.northeast.lng + bounds.southwest.lng) / 2;
  
  const latSpan = Math.abs(bounds.northeast.lat - bounds.southwest.lat);
  const lngSpan = Math.abs(bounds.northeast.lng - bounds.southwest.lng);
  const maxSpan = Math.max(latSpan, lngSpan);
  
  let zoom = 12;
  if (maxSpan < 0.05) zoom = 14;
  else if (maxSpan < 0.1) zoom = 13;
  else if (maxSpan < 0.2) zoom = 12;
  
  console.log(`Emitting polygon map-reset for ${areaName}:`, {
    center: { lat: centerLat, lng: centerLng },
    zoom: zoom,
    polygon: polygonCoords,
    polygonType: 'geographic',
    areaName: areaName
  });
  
  // Emit polygon data to map component
  emit('map-reset', {
    center: { lat: centerLat, lng: centerLng },
    zoom: zoom,
    polygon: polygonCoords,
    polygonType: 'geographic',
    areaName: areaName
  });
};

// Use viewport bounds as fallback
const useViewportBounds = (geometry) => {
  const bounds = geometry.viewport || geometry.bounds;
  if (bounds) {
    const searchBounds = {
      northeast: {
        lat: bounds.getNorthEast().lat(),
        lng: bounds.getNorthEast().lng()
      },
      southwest: {
        lat: bounds.getSouthWest().lat(),
        lng: bounds.getSouthWest().lng()
      }
    };
    
    console.log('Using viewport bounds:', searchBounds);
    applyBoundsFilter(searchBounds, true);
  }
};

// Center the map on a specific location
const centerMapOnLocation = (location) => {
  console.log('🎯 Centering map on location:', location);
  
  // Update the store with the new location
  compSetStore.setCenter({ lat: location.lat, lng: location.lng });
  compSetStore.setZoom(12); // Set appropriate zoom level for city/neighborhood view
  
  // Emit event to center the map without clearing data
  emit('map-reset', {
    center: { lat: location.lat, lng: location.lng },
    zoom: 12,
    clearMarkers: false, // Don't clear existing markers
    centerOnly: true // Just center, don't run queries or filters
  });
};

// Radius search methods
const onRadiusToggle = () => {
  if (useRadiusSearch.value && searchCenter.value) {
    // Apply radius filtering if we have a center point
    applyRadiusFilter();
  } else if (!useRadiusSearch.value) {
    // Remove radius filtering
    removeRadiusFilter();
  }
};

const onRadiusChange = () => {
  if (useRadiusSearch.value && searchCenter.value) {
    // Re-apply radius filtering with new radius
    applyRadiusFilter();
  }
};

// Load all DDA terms on mount
const loadAllDDATerms = async () => {
  try {
    console.log('📥 Loading all DDA terms for scope search...');
    const response = await axios.get('/api/v1/dda_terms', {
      params: { autocomplete: true, per_page: 1000 }
    });
    
    if (response.data && Array.isArray(response.data)) {
      allDDATerms.value = response.data.map(term => ({
        id: term.id,
        term: term.term || term.name,
        name: term.term || term.name,
        description: term.description || '',
        category: getCategoryNameById(term.dda_term_category_id),
        dda_term_category_id: term.dda_term_category_id,
        primary_dda_term_id: term.primary_dda_term_id
      }));
      console.log('✅ Loaded DDA terms for scope search:', allDDATerms.value.length);
    }
  } catch (error) {
    console.error('❌ Error loading DDA terms:', error);
  }
};

// Scope search methods - using same approach as ProjectSummary
const onScopeSearchInput = () => {
  const term = scopeSearchTerm.value.trim();
  
  if (!term || term.length < 2) {
    // Show top standard terms when no search
    const standardTermsFirst = prioritizeStandardTerms(allDDATerms.value).slice(0, 50);
    scopeSuggestions.value = standardTermsFirst;
    showScopeDropdown.value = standardTermsFirst.length > 0;
    return;
  }
  
  // Filter client-side like ProjectSummary does
  const filtered = allDDATerms.value
    .filter(ddaTerm => {
      const termLower = ddaTerm.term.toLowerCase();
      const descriptionLower = (ddaTerm.description || '').toLowerCase();
      return termLower.includes(term.toLowerCase()) || descriptionLower.includes(term.toLowerCase());
    })
    .map(t => ({
      ...t,
      matchScore: calculateTermMatchScore(t.term, term)
    }))
    .sort((a, b) => {
      // Standard terms first
      const aIsStandard = !a.primary_dda_term_id;
      const bIsStandard = !b.primary_dda_term_id;
      if (aIsStandard !== bIsStandard) {
        return bIsStandard ? 1 : -1;
      }
      // Then by match score
      return b.matchScore - a.matchScore;
    })
    .slice(0, 50);
  
  scopeSuggestions.value = filtered;
  showScopeDropdown.value = filtered.length > 0;
  console.log(`✅ Scope search: Found ${filtered.length} results for "${term}"`);
};

const selectScopeTerm = (term) => {
  // Don't add duplicates
  if (!selectedScopeTerms.value.find(t => t.id === term.id)) {
    selectedScopeTerms.value.push(term);
  }
  
  // Clear search
  scopeSearchTerm.value = '';
  scopeSuggestions.value = [];
  showScopeDropdown.value = false;
};

const removeScopeTerm = (termId) => {
  selectedScopeTerms.value = selectedScopeTerms.value.filter(t => t.id !== termId);
};

const getCategoryNameById = (categoryId) => {
  const categories = {
    197: 'Hard Costs',
    198: 'Soft Costs', 
    203: 'Acquisition',
    204: 'Financing',
    210: 'Contingencies',
    209: 'Other'
  };
  return categories[Number(categoryId)] || null;
};

const prioritizeStandardTerms = (terms) => {
  if (!terms || !Array.isArray(terms)) return [];
  
  // Standard terms have no primary_dda_term_id, extended terms do
  const standardTerms = terms.filter(term => !term.primary_dda_term_id);
  const extendedTerms = terms.filter(term => term.primary_dda_term_id);
  
  // Return standard terms first, then extended terms
  return [...standardTerms, ...extendedTerms];
};

const calculateTermMatchScore = (termName, searchTerm) => {
  if (!termName || !searchTerm) return 0;
  
  const term = termName.toLowerCase().trim();
  const search = searchTerm.toLowerCase().trim();
  
  // Exact match gets highest score
  if (term === search) return 100;
  
  // Term starts with search gets very high score
  if (term.startsWith(search)) return 90;
  
  // Search starts with term gets high score  
  if (search.startsWith(term)) return 85;
  
  // Term contains search gets good score
  if (term.includes(search)) return 70;
  
  // Search contains term gets decent score
  if (search.includes(term)) return 60;
  
  // Default low score for other matches
  return 10;
};

// Close dropdown when clicking outside
const handleClickOutside = (event) => {
  const scopeContainer = document.querySelector('.scope-input-container');
  if (scopeContainer && !scopeContainer.contains(event.target)) {
    showScopeDropdown.value = false;
  }
};

const applyRadiusFilter = () => {
  if (!searchCenter.value) {
    console.warn('No search center defined for radius filtering');
    return;
  }
  
  console.log(`Applying radius filter: ${radiusMiles.value} miles from ${searchCenter.value.formatted_address}`);
  
  // Create a circle on the map to show the search radius
  emit('map-reset', {
    center: { lat: searchCenter.value.lat, lng: searchCenter.value.lng },
    zoom: 12,
    circle: {
      center: { lat: searchCenter.value.lat, lng: searchCenter.value.lng },
      radius: radiusMiles.value * 1609.34 // Convert miles to meters
    }
  });
  
  // Filter projects within the radius (this would be handled by the map component)
  // For now, just emit the circle data
};

const applyBoundsFilter = (bounds, strictFiltering = false) => {
  console.log(`Applying geographic bounds filter:`, bounds, 'strict:', strictFiltering);
  
  // Calculate appropriate zoom level based on bounds size
  const latSpan = Math.abs(bounds.northeast.lat - bounds.southwest.lat);
  const lngSpan = Math.abs(bounds.northeast.lng - bounds.southwest.lng);
  const maxSpan = Math.max(latSpan, lngSpan);
  
  // Determine zoom level based on span (rough approximation)
  let zoom = 10; // Default
  if (maxSpan < 0.01) zoom = 15;      // Very small area (neighborhood)
  else if (maxSpan < 0.05) zoom = 13; // Small area (district)
  else if (maxSpan < 0.2) zoom = 11;  // Medium area (borough)
  else if (maxSpan < 1.0) zoom = 9;   // Large area (city)
  else zoom = 7;                      // Very large area (region)
  
  // Calculate center of the bounds
  const centerLat = (bounds.northeast.lat + bounds.southwest.lat) / 2;
  const centerLng = (bounds.northeast.lng + bounds.southwest.lng) / 2;
  
  // Emit bounds data to map component
  emit('map-reset', {
    center: { lat: centerLat, lng: centerLng },
    zoom: zoom,
    bounds: bounds,
    boundsType: 'geographic', // Distinguish from user-drawn bounds
    strictFiltering: strictFiltering // Flag for stricter project filtering
  });
};

const removeRadiusFilter = () => {
  console.log('Removing radius filter');
  
  if (searchCenter.value) {
    // Keep the map centered but remove the circle
    emit('map-reset', {
      center: { lat: searchCenter.value.lat, lng: searchCenter.value.lng },
      zoom: 12,
      circle: null
        });
      } else {
    // Reset to default view
    emit('map-reset');
  }
};

// Legacy function - removed in favor of initializePlacesAutocomplete

const assetCategoryFilteredTypes =  computed(() => dropdownStore.assetCategoryFilteredTypes);
const buildingUseFilteredTypes = computed(() => dropdownStore.buildingUseFilteredTypes);
const finishLevelTypes = computed(() => dropdownStore.finishLevelTypes);
const constructionTypesDropdown = computed(() => dropdownStore.constructionTypes);
const parkingTypesDropdown = computed(() => dropdownStore.parkingTypes);

onMounted(() => {
  // CRITICAL FIX: Force clear any cached form data to prevent mixed ID/string values
  formStore.resetForm();
  assetTypes.value = [];
  buildingUseTypes.value = [];
  constructionTypes.value = [];
  
  // Add click outside handler for scope dropdown
  document.addEventListener('click', handleClickOutside);
  
  // Load all DDA terms for scope search autocomplete
  loadAllDDATerms();
  
  dropdownStore.getInteriorFinishLevelTypes();
  
  // Fetching asset category types for the dropdown with these values only
  dropdownStore.getAssetCategoryTypes([
    ASSET_CATEGORY_TYPES.RETAIL,
    ASSET_CATEGORY_TYPES.COMMERCIAL,
    ASSET_CATEGORY_TYPES.INDUSTRIAL,
    ASSET_CATEGORY_TYPES.HOSPITALITY,
    ASSET_CATEGORY_TYPES.CIVIC_AND_CULTURAL
  ]);
  
  // Fetching building use types for the dropdown with these values only
  dropdownStore.getBuildingUseTypes([
    BUILDING_USE_TYPES_RESIDENTIAL.RENTAL_APARTMENT,
    BUILDING_USE_TYPES_RESIDENTIAL.CONDOMINIUM
  ]);

  dropdownStore.getConstructionTypes();
  dropdownStore.getParkingTypes();
  
  // Initialize Google Places Autocomplete after Google Maps API is loaded
  loadGoogleMapsAPI.then(() => {
    // Wait a bit for the DOM to be ready
    setTimeout(() => {
      initializePlacesAutocomplete();
    }, 100);
  }).catch(error => {
    console.error('Failed to load Google Maps API for Places autocomplete:', error);
  });
});

onUnmounted(() => {
  // Remove click outside handler
  document.removeEventListener('click', handleClickOutside);
});

// Watch for changes in compSetStore.QueryMapExpanded, compSetStore.getQuery, and escalation.value
// and fetch the active comp set if any of them change
// DISABLED: This was causing single project selection to load all projects
// watch(
//   [() => compSetStore.QueryMapExpanded, () => compSetStore.getQuery, () => compSetStore.getEscalation],
//   ([newQueryMapExpanded, newQuery, newEscalation], [oldQueryMapExpanded, oldQuery, oldEscalation]) => {
//     if (newQueryMapExpanded !== oldQueryMapExpanded || newQuery !== oldQuery || newEscalation !== oldEscalation) {
//       fetchActiveCompSet();
//     }
//   }
// );

// 🧠 VECTOR LEARNING INTEGRATION FOR COMP SEARCH

// Get learned suggestions for search queries with location and building type intelligence
const getLearnedSearchSuggestions = async (query) => {
  try {
    console.log('🧠 Getting learned suggestions for:', query);
    
    // 🏢 Extract location and building type patterns from query
    const extractedPatterns = extractLocationAndBuildingPatterns(query);
    console.log('🎯 Extracted patterns:', extractedPatterns);
    
    // Enhanced query with extracted patterns
    const enhancedQueries = [query];
    if (extractedPatterns.locations.length > 0) {
      enhancedQueries.push(...extractedPatterns.locations);
    }
    if (extractedPatterns.buildingTypes.length > 0) {
      enhancedQueries.push(...extractedPatterns.buildingTypes);
    }
    if (extractedPatterns.constructionTerms.length > 0) {
      enhancedQueries.push(...extractedPatterns.constructionTerms);
    }
    
    // Call existing learning system with enhanced patterns
    const response = await axios.post('/api/v1/dda_terms/classify', {
      descriptions: enhancedQueries,
      user_id: 1,
      project_id: route.params.projectId || null
    });
    
    if (response.data && response.data.classifications) {
      console.log('🎯 Got', response.data.classifications.length, 'learned insights');
      return response.data.classifications.map(c => ({
        suggestion: c.dda_term_name,
        confidence: c.confidence,
        source: c.method,
        pattern_type: determinePatternType(c.dda_term_name)
      }));
    }
    
    return [];
  } catch (error) {
    console.error('❌ Failed to get learned suggestions:', error);
    return [];
  }
};

// Record search interactions for learning
const recordCompSearchLearning = async (searchData) => {
  try {
    console.log('🧠 Recording Comp Search learning:', searchData);
    
    // Use the working DDA classification endpoint to record learning
    if (searchData.query && searchData.results_count > 0) {
      // Record successful search patterns
      await axios.post('/api/v1/dda_terms/classify', {
        descriptions: searchData.search_terms,
        user_id: searchData.user_id,
        project_id: route.params.projectId || null
      });
      
      console.log('✅ Comp Search learning recorded successfully');
    }
  } catch (error) {
    console.error('❌ Failed to record Comp Search learning:', error);
    // Don't throw - learning is optional
  }
};

// Record when users select/interact with search results
const recordCompSearchFeedback = async (query, selectedProjects, rejectedFilters = []) => {
  try {
    console.log('🧠 Recording Comp Search feedback');
    
    // Extract company names from selected projects for learning
    const companyNames = selectedProjects.map(p => p.contractor_name || p.company_name).filter(Boolean);
    
    if (companyNames.length > 0) {
      // Use DDA classification to learn company patterns
      await axios.post('/api/v1/dda_terms/classify', {
        descriptions: companyNames,
        user_id: 1,
        project_id: route.params.projectId || null
      });
    }
    
    console.log('✅ Comp Search feedback recorded');
  } catch (error) {
    console.error('❌ Failed to record feedback:', error);
  }
};

// Enhanced search with learning insights
const enhanceSearchWithLearning = async (originalQuery) => {
  try {
    const suggestions = await getLearnedSearchSuggestions(originalQuery);
    
    // Enhance query with learned patterns
    let enhancedTerms = [originalQuery];
    
    suggestions.forEach(suggestion => {
      if (suggestion.confidence > 0.5 && suggestion.suggestion) {
        enhancedTerms.push(suggestion.suggestion);
      }
    });
    
    return {
      enhanced_query: enhancedTerms.join(' '),
      applied_suggestions: suggestions,
      original_query: originalQuery
    };
  } catch (error) {
    console.error('❌ Failed to enhance search:', error);
    return { enhanced_query: originalQuery, applied_suggestions: [], original_query: originalQuery };
  }
};

// 🏢 LOCATION & BUILDING TYPE PATTERN EXTRACTION

// Extract location and building type patterns from search queries
const extractLocationAndBuildingPatterns = (query) => {
  const patterns = {
    locations: [],
    buildingTypes: [],
    constructionTerms: [],
    neighborhoods: [],
    boroughs: []
  };
  
  const lowerQuery = query.toLowerCase();
  
  // 🗽 NYC BOROUGHS
  const boroughs = ['manhattan', 'brooklyn', 'queens', 'bronx', 'staten island'];
  boroughs.forEach(borough => {
    if (lowerQuery.includes(borough)) {
      patterns.boroughs.push(borough);
      patterns.locations.push(borough);
    }
  });
  
  // 🏙️ NYC NEIGHBORHOODS
  const neighborhoods = [
    'upper east side', 'upper west side', 'midtown', 'downtown', 'soho', 'tribeca',
    'chelsea', 'village', 'east village', 'west village', 'murray hill',
    'financial district', 'battery park', 'hell\'s kitchen', 'times square',
    'williamsburg', 'dumbo', 'park slope', 'red hook', 'bushwick', 'greenpoint',
    'long island city', 'astoria', 'flushing', 'forest hills', 'jamaica',
    'mott haven', 'hunts point', 'concourse', 'fordham', 'riverdale'
  ];
  neighborhoods.forEach(neighborhood => {
    if (lowerQuery.includes(neighborhood)) {
      patterns.neighborhoods.push(neighborhood);
      patterns.locations.push(neighborhood);
    }
  });
  
  // 🏢 BUILDING TYPES
  const buildingTypes = [
    // Residential
    'residential', 'apartment', 'condo', 'condominium', 'co-op', 'cooperative',
    'single family', 'multi family', 'duplex', 'triplex', 'townhouse', 'brownstone',
    'luxury', 'affordable housing', 'senior housing', 'student housing',
    
    // Commercial
    'commercial', 'office', 'retail', 'restaurant', 'hotel', 'hospitality',
    'medical', 'clinic', 'hospital', 'healthcare', 'warehouse', 'industrial',
    'manufacturing', 'data center', 'laboratory', 'research facility',
    
    // Mixed Use
    'mixed use', 'mixed-use', 'live work', 'ground floor retail',
    
    // Institutional
    'school', 'education', 'university', 'library', 'museum', 'cultural',
    'religious', 'church', 'synagogue', 'mosque', 'community center',
    
    // Infrastructure
    'infrastructure', 'transportation', 'subway', 'bridge', 'tunnel',
    'utility', 'power plant', 'water treatment'
  ];
  buildingTypes.forEach(type => {
    if (lowerQuery.includes(type)) {
      patterns.buildingTypes.push(type);
    }
  });
  
  // 🔨 CONSTRUCTION TERMS
  const constructionTerms = [
    'new construction', 'renovation', 'restoration', 'rehabilitation', 'retrofit',
    'addition', 'extension', 'gut renovation', 'facade', 'rooftop', 'basement',
    'foundation', 'structural', 'seismic', 'green building', 'leed', 'sustainable',
    'historic', 'landmark', 'adaptive reuse', 'conversion', 'modernization'
  ];
  constructionTerms.forEach(term => {
    if (lowerQuery.includes(term)) {
      patterns.constructionTerms.push(term);
    }
  });
  
  return patterns;
};

// Determine what type of pattern a DDA term represents
const determinePatternType = (ddaTermName) => {
  if (!ddaTermName) return 'unknown';
  
  const term = ddaTermName.toLowerCase();
  
  // Location patterns
  if (term.includes('manhattan') || term.includes('brooklyn') || term.includes('queens') || 
      term.includes('bronx') || term.includes('nyc') || term.includes('new york')) {
    return 'location';
  }
  
  // Building type patterns
  if (term.includes('residential') || term.includes('commercial') || term.includes('office') ||
      term.includes('retail') || term.includes('hotel') || term.includes('apartment')) {
    return 'building_type';
  }
  
  // Construction patterns
  if (term.includes('construction') || term.includes('renovation') || term.includes('building') ||
      term.includes('electrical') || term.includes('plumbing') || term.includes('hvac')) {
    return 'construction';
  }
  
  return 'general';
};

// Enhanced learning specifically for location and building patterns
const recordLocationBuildingLearning = async (searchData) => {
  try {
    console.log('🏢 Recording location/building learning:', searchData);
    
    // Extract all location and building patterns from search
    const allPatterns = [];
    
    // Add location patterns
    if (searchData.location_data) {
      allPatterns.push(...searchData.location_data.boroughs || []);
      allPatterns.push(...searchData.location_data.neighborhoods || []);
    }
    
    // Add building type patterns
    if (searchData.building_data) {
      allPatterns.push(...searchData.building_data.types || []);
      allPatterns.push(...searchData.building_data.construction_terms || []);
    }
    
    // Add selected project patterns for learning
    if (searchData.selected_projects) {
      searchData.selected_projects.forEach(project => {
        if (project.location) allPatterns.push(project.location);
        if (project.building_type) allPatterns.push(project.building_type);
        if (project.asset_type) allPatterns.push(project.asset_type);
      });
    }
    
    // Record all patterns for learning
    if (allPatterns.length > 0) {
      await axios.post('/api/v1/dda_terms/classify', {
        descriptions: allPatterns,
        user_id: searchData.user_id || 1,
        project_id: null // Location/building learning is project-agnostic
      });
      
      console.log('✅ Location/building patterns recorded:', allPatterns.length);
    }
    
  } catch (error) {
    console.error('❌ Failed to record location/building learning:', error);
  }
};

// Export for other components
window.CompSearchLearning = {
  getLearnedSearchSuggestions,
  recordCompSearchLearning,
  recordCompSearchFeedback,
  enhanceSearchWithLearning,
  extractLocationAndBuildingPatterns,
  recordLocationBuildingLearning,
  determinePatternType
};

</script>

<style scoped lang="scss">
@import "./src/assets/main.scss";

// Sidebar
.side-bar-comp-search {
  position: fixed;
  display: flex;
  height: 100vh;
  top: 50px;
  background: transparent;
  box-shadow: 6px 0 18px rgba(0, 0, 0, 0.06);
  z-index: 5;
}

// HIDE collapse arrows to prevent reopening issue
.side-bar-comp-search .expand-collapse {
  display: none !important;
}

.comp-search-title {
  font-size: 16px;
  font-family: 'Inter';
  font-weight: bold;
  color: $navyBlue;
  padding: 10px 0 20px 0;
}

.side-bar-comp-search.open {
  width: 310px;
  transition: width 0.5s ease;
}

.side-bar-comp-search.closed {
  width: 0;
  transition: width 0.5s ease;
}

.hidden {
  display: none;
}

.comp-search {
  padding: 10px;
  font-family: 'Inter';
  overflow-y: scroll;
}

.comp-search::-webkit-scrollbar {
  width: 5px;
  height: 8px;
  background-color: $white1;
}

.comp-search::-webkit-scrollbar-thumb {
  background: $lightGray1;
}

h4 {
  color: $navyBlue;
}

.header-details-with-desc {
  color: $navyBlue;
  display: flex;
  align-items: center;

  div {
    font-size: 14px;
    font-weight: bold;
    padding-right: 0.5rem;
  }

  p {
    font-size: 10px;
  }
}

.header-details {
  color: $navyBlue;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 0;
}

.header-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.left-div .right-div {
  flex: 1;
}

.right-div {
  p {
    margin: 5px;
  }
}

.divider {
  border: 1px solid lightgray;
}

.location-container {
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
  position: relative;

  label {
    margin-bottom: 5px;
    color: $navyBlue;
    font-size: 14px;
    font-weight: bold;
  }

  input[type=text] {
    color: $brightBlue1;
    background-color: $lightGray1;
    border: 1px solid $lightGray1;
    border-radius: 5px;
    padding: 5px;
    height: 10px;
    width: 85%
  }

  input[type=text]:focus {
    border-color: $brightBlue1;
    outline: $brightBlue1;
  }

  .location-search-box {
    color: $brightBlue1;
    background-color: $lightGray1;
    border: 1px solid $lightGray1;
    border-radius: 5px;
    padding: 5px;
    height: 10px;
    width: 85%
  }
}

// Location Search Heading
.location-search-heading {
  font-size: 14px;
  font-weight: 600;
  color: $navyBlue;
  margin-bottom: 10px;
  padding-left: 0;
}

// Radius Search Styling
.radius-search-container {
  margin-top: 15px;
  padding: 10px 0;
  
  .radius-checkbox-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 10px;
    
    input[type="checkbox"] {
      margin-right: 8px;
      cursor: pointer;
    }
    
    label {
      font-size: 12px;
      color: $navyBlue;
      cursor: pointer;
      margin-bottom: 0;
    }
  }
  
  .radius-input-container {
    display: flex;
    align-items: center;
    margin-left: 20px;
    
    .radius-input {
      width: 60px;
      padding: 5px;
      border: 1px solid $lightGray1;
      border-radius: 3px;
      font-size: 12px;
      color: $brightBlue1;
      background-color: $lightGray1;
      margin-right: 8px;
    }
    
    .radius-input:focus {
      border-color: $brightBlue1;
      outline: none;
    }
    
    .radius-label {
      font-size: 12px;
      color: $navyBlue;
    }
  }
}

.scope-search-container {
  margin-top: 15px;
  padding: 10px 0;
  
  .radius-checkbox-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 10px;
    
    input[type="checkbox"] {
      margin-right: 8px;
      cursor: pointer;
    }
    
    label {
      font-size: 12px;
      color: $navyBlue;
      cursor: pointer;
      margin-bottom: 0;
    }
  }
  
  .scope-input-container {
    margin-left: 20px;
    
    .autocomplete-wrapper {
      position: relative;
      width: 100%;
      
      .scope-search-input {
        width: 100%;
        padding: 8px;
        border: 1px solid $lightGray1;
        border-radius: 3px;
        font-size: 12px;
        color: $navyBlue;
        background-color: white;
        
        &:focus {
          border-color: $brightBlue1;
          outline: none;
        }
        
        &::placeholder {
          color: #999;
        }
      }
      
      .scope-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        max-height: 300px;
        overflow-y: auto;
        background: white;
        border: 1px solid $lightGray1;
        border-radius: 3px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        margin-top: 2px;
        
        .scope-dropdown-item {
          padding: 8px 12px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #f0f0f0;
          
          &:hover {
            background-color: #f5f5f5;
          }
          
          &:last-child {
            border-bottom: none;
          }
          
          .term-name {
            font-size: 12px;
            color: $navyBlue;
            font-weight: 500;
          }
          
          .term-category {
            font-size: 11px;
            color: #666;
            font-style: italic;
          }
        }
      }
    }
    
    .selected-scopes {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 10px;
      
      .scope-tag {
        display: inline-flex;
        align-items: center;
        padding: 5px 10px;
        background-color: $brightBlue1;
        color: white;
        border-radius: 15px;
        font-size: 11px;
        
        .remove-scope {
          margin-left: 6px;
          background: none;
          border: none;
          color: white;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          padding: 0;
          line-height: 1;
          
          &:hover {
            color: #ffcccc;
          }
        }
      }
    }
  }
}

.building-details-container,
.construction-details-container,
.scope-of-work-container {
  padding: 15px 0px;

  label {
    margin-bottom: 5px;
    color: $navyBlue;
    font-size: 12px;
  }
}

.asset-type-container {
  ul {
    position: relative;
    padding-left: 0;
    font-size: 12px;
    column-count: 2;
    list-style: none;
  }
}

.parking-type-container {
  .parking-type-input-container {
    display: flex;
    margin-bottom: 3px;

    .checkbox-text-input {
      display: flex;
      justify-content: flex-end;

      input[type=number] {
        color: $brightBlue1;
        background-color: $lightGray1;
        border: 1px solid $lightGray1;
        border-radius: 5px;
        padding: 5px;
        height: 10px;
        width: 30%;
      }
    }
  }

  ul {
    padding-left: 0;
  }
}

.construction-completion-date-container,
.sizing-container,
.project-buyout-date-container {
  margin-bottom: 10px;
}

.construction-completion-date-input-container,
.sizing-input-container,
.units-input-container,
.floors-input-container,
.project-buyout-date-input-container {
  display: flex;
  align-items: center;
  font-size: 12px;

  input[type=number] {
    color: $brightBlue1;
    background-color: $lightGray1;
    border: 1px solid $lightGray1;
    border-radius: 5px;
    padding: 5px;
    height: 10px;
    width: 30%;
  }

  input[type=number]:focus {
    border-color: $brightBlue1;
    outline: $brightBlue1;
  }
}

.accordion-panel-header {
  display: flex;
  align-items: center;
  position: relative;
  width: 97%;
  height: 27px;

  label {
    font-size: 14px;
  }
}

.construction-type-container {
  ul {
    position: relative;
    padding-left: 0;
    font-size: 12px;
    column-count: 2;
    list-style: none;
  }
}

.label-text-spacing {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

// Custom Dropdown
.custom-select {
  width: 100%;
  position: relative;
  font-family: inherit;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-top: 5px;

  label {
    color: $navyBlue; // Updated since Scope of Work is now functional
  }

  select {
    appearance: none;
    font-family: inherit;
    -webkit-appearance: none;
    padding: 5px;
    color: $brightBlue1;
    cursor: pointer;
    width: 100%;
    font-size: 12px;
    line-height: 1;
    border: 0;
    border-radius: 5px;
    background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right $lightGray1;
    background-position-x: 5px;
    text-align-last: right;
    background-size: 10px;
  }

  select option {
    background-color: white;
    color: #2c3e50;
    padding: 8px;
    font-size: 12px;
  }

  select option:hover {
    background-color: #f8f9fa;
    color: #2c3e50;
  }

  select option:selected {
    background-color: #4A5FD5;
    color: white;
  }

  select:focus {
    border-color: $brightBlue1;
    outline: $brightBlue1;
  }

  select:disabled {
    cursor: not-allowed;
  }
}

// Custom Multiple Select
.custom-multiple-select {
  width: 100%;
  position: relative;
  font-family: inherit;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-top: 5px;


  select {
    appearance: none;
    font-family: inherit;
    -webkit-appearance: none;
    padding: 5px;
    color: $brightBlue1;
    cursor: pointer;
    width: 100%;
    font-size: 12px;
    line-height: 1;
    border: 0;
    border-radius: 5px;
    background: $lightGray1;
    background-position-x: 5px;
    text-align-last: right;
    background-size: 10px;
  }

  select:focus {
    border-color: $brightBlue1;
    outline: $brightBlue1;
  }
}

// Action Buttons
.action-btn-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 8vh;
}

.primary-action-button {
  background-color: $mediumBlue2;
  color: white;
  border: 0;
  border-radius: 4px;
  margin: 8px;
  cursor: pointer;
  padding: 10px;
  font-size: 12px;
}

// Secondary buttons are functional
.secondary-action-button.clear-filters {
  background-color: transparent;
  color: $brightBlue1; 
  border: 0;
  cursor: pointer;
  padding: 5px;
  font-size: 12px;
}

.secondary-action-button:hover {
  text-decoration: underline;
}


// Secondary buttons that are not functional
.secondary-action-button.my-searches,
.secondary-action-button.save-filters  {
  background-color: transparent;
  border: 0;
  padding: 5px;
  font-size: 12px;
  color: $lightGray1;
  cursor: not-allowed;
}

.secondary-action-button:hover {
  text-decoration: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
  text-align: right;
}

.custom-checkbox-label {
  padding-left: 25px;
}

.escalation {
  margin: 15px 0;
}

.escalation-checkbox {
  display: flex;
  flex-direction: row;
}

.escalation-options {
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  .escalation-label {
    font-size: 12px;
    padding: 10px;
  }

  .or {
    justify-content: center;
    padding-left: 15px;
  }

  .custom {
    .escalation-input {
      display: flex;
      justify-content: center;

      input[type=text] {
        color: $brightBlue1;
        background-color: $lightGray1;
        border: 1px solid $lightGray1;
        border-radius: 5px;
        padding: 5px;
        height: 10px;
        width: 30%;
      }

      input[type=text]:focus {
        border-color: $brightBlue1;
        outline: $brightBlue1;
      }
    }
  }
}

.escalation-option {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}

.loading-indicator {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 15px 30px;
  border-radius: 5px;
  z-index: 9999;
  font-weight: bold;
}

/* Project Autocomplete Styles */
.project-autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
}

.autocomplete-item {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}

.autocomplete-item:hover {
  background-color: #f8f9fa;
}

.autocomplete-item:last-child {
  border-bottom: none;
}

.autocomplete-item strong {
  color: #333;
  font-size: 14px;
}

.project-details {
  color: #666;
  font-size: 12px;
  margin-top: 4px;
}

.location-container {
  position: relative;
}

</style>